import { ForkEffect, put, takeLatest } from 'redux-saga/effects';

import { PayloadAction } from '@reduxjs/toolkit';

import { AnalyticsActions } from '../types/actions';
import { IAnalyticsCommonAPI } from '../types/api';

export const setBoardDateRangeCommonWatcher = (
  api: IAnalyticsCommonAPI,
  actions: AnalyticsActions
): (() => Generator<ForkEffect<never>, void>) => {
  function* worker(action: PayloadAction<[string, string]>) {
    const { success, failure, fulfill } = actions.analyticsCommonSetBoardDateRoutine;
    const { payload } = action;
    try {
      yield put(success({ date: payload }));
    } catch (error) {
      console.error(error);
      yield put(failure(error));
    } finally {
      yield put(fulfill());
    }
  }

  function* watcher() {
    yield takeLatest(actions.analyticsCommonSetBoardDateRoutine.TRIGGER, worker);
  }

  return watcher;
};
